import { Col, PageHeader, Row } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LEFT_COL_WIDTH } from 'utils/constants';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';
import TaskListCard from './parts/TaskListCard/TaskListCard';
import TaskListFiltersCard from './parts/TaskListFiltersCard/TaskListFiltersCard';
import TasksAndRunsWithoutTaskSwitch from './parts/TasksAndRunsWithoutTaskSwitch/TasksAndRunsWithoutTaskSwitch';

interface IProps {}

const RightCol = styled(Col)`
  height: calc(100vh - 170px);
  ${cssMediaBreakpoints.mobileOrTablet} {
    height: auto;
  }
`;

const TaskListPage: FC<IProps> = () => {
  const { t } = useTranslation();

  const { mobileOrTablet } = useResponsiveQuery();

  const responsivePadding = mobileOrTablet ? 6 : 12;

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Task.List.Tasks', 'Tasks')}
      />
      <Row
        wrap={mobileOrTablet}
        gutter={responsivePadding}
        style={{
          paddingLeft: responsivePadding,
          paddingTop: responsivePadding,
          width: '100%',
        }}
      >
        <Col
          style={{
            paddingBottom: 6,
            minWidth: mobileOrTablet ? '100%' : LEFT_COL_WIDTH,
            maxWidth: mobileOrTablet ? '100%' : LEFT_COL_WIDTH,
            maxHeight: `calc(100vh - 164px)`,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <TasksAndRunsWithoutTaskSwitch />
          <TaskListFiltersCard />
        </Col>
        <RightCol flex="auto">
          <TaskListCard />
        </RightCol>
      </Row>
    </>
  );
};

export default TaskListPage;
